export default __webpack_public_path__ + "static/media/video.33f3e266.svg";